/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const USER_PROFILE = [
    {
        userId: "swiss-timing",
        userName: "SWISS TIMING",
        bannerImg: "https://i.ibb.co/vkmNKyH/Athletics-1900x400.jpg",
        userImg: "https://i.ibb.co/7CpTJPz/swiss-timing-logo-white-bg.png",
        description:
            "Although Swiss Timing as an independent entity was officially founded in July of 1972, its roots can be traced back more than a century to the earliest sports timekeeping activities of its sister brands, Omega and Longines.",
        summary: [
            {
                label: "collected",
                value: 0,
            },
            {
                label: "created",
                value: 22,
            },
            {
                label: "offers received",
                value: 15,
            },
            {
                label: "offers made",
                value: 0,
            },
        ],
    },
];
